import { RequestOverlay } from '@shared/ui/request-overlay';
import classes from './page-loader.module.css';

export const PageLoader = ({
  label = 'Загружаем страницу',
  compact = false,
}: {
  label?: string;
  compact?: boolean;
}) => (
  <div className={classes.root} data-compact={compact || undefined}>
    <RequestOverlay loading page={!compact} label={label} />
  </div>
);
